export default __webpack_public_path__ + "static/media/chapterTest.4d91dc88.svg";